var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useUnreadCommentsNumber } from '@data/hooks/comments';
import { useUpdateUserSettingsActions } from '@data/hooks/currentUser';
import { useHover } from '@hooks/useHover';
import { useModalPosition } from '@hooks/useModalPosition';
import { useOnOutClick } from '@hooks/useOnOutClick';
import ConfigMenu from '@main/conf/ConfigMenu';
import FarseerLogo from '@shared/icons/FarseerLogo';
import UserAvatar from '@shared/userprofile/Avatar';
import { Bubble } from '@styled/Basic';
import { Color } from '@util/enums';
import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { AiFillTag } from 'react-icons/ai';
import { BiChevronDown, BiLogOut } from 'react-icons/bi';
import { FaCog, FaUser } from 'react-icons/fa';
import { MdMessage } from 'react-icons/md';
import { Link, NavLink, useParams } from 'react-router-dom';
import { FeatureWrapper } from '../base/FeatureWrapper';
import { useLanguage } from '../base/LanguageProvider';
import SignInActions from '../base/SignInActions';
import { useAuth } from '../providers/AuthProvider';
var NAV_RIGHT = {
    display: 'flex',
    justifyContent: 'right',
    alignItems: 'center',
    height: '100%',
};
var NAV_LEFT = {
    display: 'flex',
    justifyContent: 'left',
    alignItems: 'center',
    height: '100%',
};
var MENU_ARROW = {
    position: 'absolute',
    left: 'calc(50% - 10px)',
    top: -10,
    transform: 'rotate(45deg)',
    backgroundColor: 'white',
    borderTop: '1px solid #E7EAF0',
    borderLeft: '1px solid #E7EAF0',
    zIndex: 10002,
    width: 20,
    height: 20,
};
var NAV_ITEM = {
    position: 'relative',
    height: '100%',
    display: 'flex',
    paddingLeft: 20,
    paddingRight: 20,
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    fontSize: '14px',
};
var MENU_ICON_CONTAINER = {
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
};
var USER_PROFILE_CONTAINER = {
    backgroundColor: '#3B85FF',
    cursor: 'pointer',
    width: 169,
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
};
var USER_OPTION = {
    backgroundColor: 'white',
    width: '100%',
    height: 44,
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 11,
    paddingRight: 11,
    justifyContent: 'start',
};
var USER_OPTIONS = {
    width: 169,
    top: '100%',
    display: 'flex',
    cursor: 'pointer',
    position: 'absolute',
    alignItems: 'center',
    flexDirection: 'column',
    backgroundColor: 'white',
    border: '1px solid #E7EAF0',
    borderTop: 'none',
    zIndex: 10005,
    boxShadow: '0px 4px 16px rgba(107, 131, 160, 0.15)',
};
var HEADER = {
    top: 0,
    left: 0,
    right: 0,
    height: 44,
    display: 'flex',
    paddingLeft: 22,
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#001024',
};
var MENU_CONTAINER = {
    width: 350,
    borderRadius: 5,
    position: 'absolute',
    backgroundColor: 'white',
    border: '1px solid #E7EAF0',
    boxShadow: '0px 4px 16px rgba(107, 131, 160, 0.15)',
    cursor: 'unset',
    zIndex: 10001,
};
var NAV_MENU_ITEM = __assign(__assign({}, NAV_ITEM), { cursor: 'pointer' });
function HomeLogo() {
    return (React.createElement(Link, { style: {
            width: 100,
            height: '100%',
            marginRight: 22,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }, to: "/" },
        React.createElement(FarseerLogo, null)));
}
function UserOption(_a) {
    var Icon = _a.Icon, title = _a.title, _b = _a.color, color = _b === void 0 ? 'black' : _b, action = _a.action;
    var L = useLanguage().L;
    var _c = __read(useHover(), 2), ref = _c[0], isHovered = _c[1];
    var style = isHovered
        ? __assign(__assign({}, USER_OPTION), { color: color, backgroundColor: '#E7EAF0' }) : __assign(__assign({}, USER_OPTION), { color: color });
    return (React.createElement("div", { ref: ref, style: style, onClick: action },
        React.createElement("span", { style: { display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: 15 } }, React.createElement(Icon, { color: color, size: 20 })),
        React.createElement("span", { style: { whiteSpace: 'nowrap' } }, L(title))));
}
function UserProfileMenu() {
    var _a, _b, _c, _d;
    var user = useAuth().user;
    var _e = __read(useState(false), 2), show = _e[0], setShow = _e[1];
    var _f = __read(useOnOutClick(function (e) { return setShow(false); }), 2), targetRef = _f[0], ignoreRef = _f[1];
    var initials = user ? "".concat((_b = (_a = user.firstName) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : '').concat((_d = (_c = user.lastName) === null || _c === void 0 ? void 0 : _c[0]) !== null && _d !== void 0 ? _d : '') : '';
    var name = user ? "".concat(user.firstName, " ").concat(user.lastName) : '';
    var userOptions = [
        {
            Icon: FaUser,
            title: 'My Account',
            action: function () {
                window.location.hash = '/myaccount';
            },
        },
        {
            Icon: BiLogOut,
            color: Color.RED,
            title: 'Sign Out',
            action: function () {
                SignInActions.signOut();
            },
        },
    ];
    var optionItems = userOptions.map(function (o) { return React.createElement(UserOption, __assign({ key: o.title }, o)); });
    var options = show ? (React.createElement("div", { ref: targetRef, style: USER_OPTIONS }, optionItems)) : null;
    return (React.createElement("div", { ref: ignoreRef, style: USER_PROFILE_CONTAINER, onClick: function () { return setShow(!show); } },
        React.createElement(UserAvatar, { size: 22, initials: initials, backgroundColor: "white", color: "#3B85FF" }),
        React.createElement("span", { style: { color: 'white', whiteSpace: 'nowrap' } }, name),
        React.createElement(BiChevronDown, { size: 20, color: "white" }),
        options));
}
function NavMenuItem(_a) {
    var Icon = _a.Icon, Menu = _a.Menu, menuHeight = _a.menuHeight;
    var _b = __read(useModalPosition({
        addOffset: function (_a) {
            var height = _a.height, width = _a.width;
            return {
                offsetTop: height + 10,
                offsetLeft: (350 - width) / -2,
            };
        },
    }), 4), clickTarget = _b[0], modalRef = _b[1], position = _b[2], clearPositionData = _b[3];
    function closeHandler() {
        clearPositionData();
    }
    var itemStyle = position
        ? __assign(__assign({}, NAV_MENU_ITEM), { color: '#001024', backgroundColor: 'white' }) : __assign(__assign({}, NAV_MENU_ITEM), { color: 'white' });
    var menuStyle = menuHeight ? __assign(__assign({}, MENU_CONTAINER), { height: menuHeight }) : MENU_CONTAINER;
    var menu = position ? (React.createElement("div", { ref: modalRef, style: __assign(__assign({}, menuStyle), { left: position.left, top: position.top }) },
        React.createElement("div", { style: MENU_ARROW }),
        React.createElement(Menu, { closeMenuHandler: closeHandler }))) : null;
    return (React.createElement("div", { ref: clickTarget, style: itemStyle },
        React.createElement("div", { style: MENU_ICON_CONTAINER },
            React.createElement(Icon, { size: 20, color: position ? '#001024' : 'white' })),
        ReactDOM.createPortal(menu, document.getElementById('portal'))));
}
function ActionMenuItem(_a) {
    var Icon = _a.Icon, isActive = _a.isActive, action = _a.action, number = _a.number;
    var itemStyle = isActive
        ? __assign(__assign({}, NAV_MENU_ITEM), { color: '#001024', backgroundColor: 'white' }) : __assign(__assign({}, NAV_MENU_ITEM), { color: 'white' });
    return (React.createElement("div", { style: itemStyle, onClick: function () { return action(); } },
        React.createElement("div", { style: MENU_ICON_CONTAINER },
            React.createElement(Icon, { size: 20, color: isActive ? '#001024' : 'white' }),
            number ? React.createElement(Bubble, null, number) : null)));
}
function NavItem(_a) {
    var path = _a.path, content = _a.content;
    return (React.createElement(NavLink, { style: function (_a) {
            var isActive = _a.isActive;
            return isActive ? __assign(__assign({}, NAV_ITEM), { color: '#001024', backgroundColor: 'white' }) : __assign(__assign({}, NAV_ITEM), { color: 'white' });
        }, to: path, replace: true }, content));
}
var NAVIGATION_CONFIGURATION = Object.freeze({
    Dashboard: { path: 'dashboard' },
    Sheets: { path: 'sheet' },
    Import: { path: 'import', featureKey: 'canSeeImport' },
    'Remote jobs': { path: 'remote-jobs', featureKey: 'canSeeRemoteJobs' },
    Database: { path: 'database', featureKey: 'canSeeTagsInNavbar' },
});
function HeaderNavbar() {
    var userSettings = useAuth().settings;
    var _a = useUpdateUserSettingsActions(), toggleShowTagsSidebar = _a.toggleShowTagsSidebar, toggleShowTasksSidebar = _a.toggleShowTasksSidebar;
    var L = useLanguage().L;
    var path = useParams().clusterPath;
    var unreadTasksNumber = useUnreadCommentsNumber(path);
    var actionNavigationConfiguration = [
        {
            Icon: MdMessage,
            action: function () {
                toggleShowTasksSidebar(!userSettings.show_tasks_sidebar);
            },
            notificationNumber: unreadTasksNumber,
            isActive: userSettings.show_tasks_sidebar,
            featureKey: 'canSeeComments',
        },
        {
            Icon: AiFillTag,
            action: function () {
                toggleShowTagsSidebar(!userSettings.show_tags_sidebar);
            },
            isActive: userSettings.show_tags_sidebar,
            featureKey: 'canSeeTagsSidebar',
        },
    ];
    var navLeft = Object.entries(NAVIGATION_CONFIGURATION).map(function (_a, idx) {
        var _b = __read(_a, 2), name = _b[0], config = _b[1];
        var navItem = React.createElement(NavItem, { key: idx, content: L(name), path: config.path });
        return config.featureKey ? (React.createElement(FeatureWrapper, { key: config.featureKey, featureKey: config.featureKey }, navItem)) : (navItem);
    });
    var actionNavRight = actionNavigationConfiguration.map(function (c, idx) {
        var actionMenuItem = (React.createElement(ActionMenuItem, { key: idx, Icon: c.Icon, isActive: c.isActive, action: c.action, number: c.notificationNumber }));
        return c.featureKey ? (React.createElement(FeatureWrapper, { key: c.featureKey, featureKey: c.featureKey }, actionMenuItem)) : (actionMenuItem);
    });
    return (React.createElement("header", { className: "unselectable", style: HEADER },
        React.createElement("nav", { style: NAV_LEFT },
            React.createElement(HomeLogo, null),
            window.location.host.lastIndexOf('test') !== -1 && (React.createElement("div", { style: { color: 'orange' } },
                React.createElement("b", null, "TEST"))),
            navLeft),
        React.createElement("nav", { style: NAV_RIGHT },
            actionNavRight,
            React.createElement(FeatureWrapper, { featureKey: "canSeeAdministrationMenu" },
                React.createElement(NavMenuItem, { Icon: FaCog, Menu: ConfigMenu })),
            React.createElement(UserProfileMenu, null))));
}
export default HeaderNavbar;
